import { observable, runInAction } from 'mobx';
import { ActivitiesOfContactSegment, ContactSegmentModel, DetailsContactSegmentModel, IContactSegmentServices } from 'services/Main/contactSegment_services';
import { DetailContactSegment } from 'services/Main/customerSegment_services';
import { DataResponse } from 'services/response';
import { string } from 'yup/lib/locale';

export type ContactSegmentStore = {
  // Danh sách contact segments
  listContactSegment: DataResponse<Array<ContactSegmentModel>>
  // danh sách hoạt động của Contact segment theo type
  activitiesOfContactSegment: DataResponse<Array<ActivitiesOfContactSegment>>
  // Tạo mới contact segments
  createContactSegment: DataResponse<null>

  deleleContactSegment: DataResponse<null>
  // Lấy danh sách khách hàng của contact segment
  customerOfContactSegment: DataResponse<DetailContactSegment>

  // lấy danh sách detail trong contact segment lúc thêm mới
  detailsContactSegment: DataResponse<Array<DetailsContactSegmentModel>>
};

export interface IContactSegmentPresenter {
  createStore(): ContactSegmentStore;
  //    Lấy danh sách contact segments
  getlistContactSegments(store: ContactSegmentStore, data: object): Promise<void>
  // danh sách hoạt động của Contact segment theo type
  getActivitiesOfContactSegment(store: ContactSegmentStore, data: object): Promise<void>
  // Tạo mới Contact segment
  createContactSegment(store: ContactSegmentStore, data: object): Promise<boolean>
  // Lấy danh sách khách hàng của contact segment theo type
  getCustomerOfContactSegment(store: ContactSegmentStore, data: object): Promise<void>

  // cập nhật contact segment
  editContactSegment(store: ContactSegmentStore, data: object): Promise<void>

  // Delete contact segment
  deleteContactSegment(store: ContactSegmentStore, id: string): Promise<void>

  // lấy danh sách theo id (mảng)
  getContact(store: ContactSegmentStore, profileIds: string): Promise<void>

  // export excel
  exportExcel(data: object): Promise<void>

}

export function createContactSegmentPresenter({ contactSegmentServices }: { contactSegmentServices: IContactSegmentServices }): IContactSegmentPresenter {
  return {
    createStore: (): ContactSegmentStore =>
      observable({
        listContactSegment: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // danh sách hoạt động của Contact segment theo type
        activitiesOfContactSegment: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // Tạo mới contact segments
        createContactSegment: {
          data: null,
          message: '',
          isSuccess: false,
        },
        deleleContactSegment: {
          data: null,
          message: '',
          isSuccess: false,
        },
        // Lấy danh sách khách hàng của contact segment
        customerOfContactSegment: {
          data: {
            contactSegmentName: '',
            description: '',
            listKH: [],
            companyCode: '',
            pageSP: {
              totalCount: 0,
              pageIndex: 0,
              pageSize: 0,
              totalPages: 0
            }
          },
          message: '',
          isSuccess: false,
        },
        detailsContactSegment: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
      }),
    //    Lấy danh sách contact segments
    getlistContactSegments: async (store, dataSearch) => {
      try {
        const result = await contactSegmentServices.getlistContactSegments(dataSearch);
        runInAction(() => {
          store.listContactSegment.data = result.data;
          store.listContactSegment.isSuccess = result.isSuccess;
          store.listContactSegment.message = result.message;
          store.listContactSegment.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // danh sách hoạt động của Contact segment theo type
    getActivitiesOfContactSegment: async (store, data) => {
      try {
        const result = await contactSegmentServices.getActivitiesOfContactSegment(data);
        runInAction(() => {
          store.activitiesOfContactSegment.data = result.data;
          store.activitiesOfContactSegment.isSuccess = result.isSuccess;
          store.activitiesOfContactSegment.message = result.message;
          store.activitiesOfContactSegment.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Tạo mới Contact segment
    createContactSegment: async (store, data) => {
      try {
        const result = await contactSegmentServices.createContactSegment(data);
        runInAction(() => {
          store.createContactSegment.isSuccess = result.isSuccess;
          store.createContactSegment.message = result.message;
        });
        return result.isSuccess;
      } catch (error) {
        console.log(error);
        return false
      }
    },

    // Lấy danh sách khách hàng của contact segment theo type
    getCustomerOfContactSegment: async (store, data) => {
      try {
        const result = await contactSegmentServices.getCustomerOfContactSegment(data);
        runInAction(() => {
          store.customerOfContactSegment.data = result.data;
          store.customerOfContactSegment.isSuccess = result.isSuccess;
          store.customerOfContactSegment.message = result.message;
          store.customerOfContactSegment.paging = result.data.pagingSP;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // cập nhật contact segment
    editContactSegment: async (store, data) => {
      try {
        const result = await contactSegmentServices.editContactSegment(data);
        runInAction(() => {
          store.createContactSegment.data = result.data;
          store.createContactSegment.isSuccess = result.isSuccess;
          store.createContactSegment.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Delete contact segment
    deleteContactSegment: async (store, id) => {
      try {
        const result = await contactSegmentServices.deleteContactSegment(id);
        runInAction(() => {
          store.deleleContactSegment.isSuccess = result.isSuccess;
          store.deleleContactSegment.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // lấy danh sách theo id (mảng)
    getContact: async (store, profileIds) => {
      try {
        const result = await contactSegmentServices.getContact(profileIds);
        runInAction(() => {
          store.detailsContactSegment.data = result.data;
          store.detailsContactSegment.isSuccess = result.isSuccess;
          store.detailsContactSegment.message = result.message;
          store.detailsContactSegment.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },



    // export
    exportExcel: async (data) => {
      try {
        await contactSegmentServices.exportExcel(data);
      } catch (error) {
        console.log(error);
      }
    }
  };
}
